import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

const apiOrigin = new URL(environment.apiUrl).origin;

export const clientOriginInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(apiOrigin + '/')) {
    return next(req);
  }

  const cloned = req.clone({
    setHeaders: {
      'X-Client-Origin': environment.clientOrigin,
    },
  });

  return next(cloned);
};
